import React from 'react';
import { Link } from 'react-router-dom';
import { useAppSelector } from '../store/hooks';
import { selectCartItemsCount } from '../store/slices/cartSlice';
import './CartIcon.css';

const CartIcon = () => {
  const itemCount = useAppSelector(selectCartItemsCount);

  return (
    <Link to="/cart" className="cart-icon-link">
      <button className="icon-btn cart-icon-btn">
        <svg className="cart-icon" width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <circle cx="9" cy="21" r="1"></circle>
          <circle cx="20" cy="21" r="1"></circle>
          <path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"></path>
        </svg>
        {itemCount > 0 && <span className="cart-badge">{itemCount}</span>}
      </button>
    </Link>
  );
};

export default CartIcon;
